export const SCOPE = 'common';
export const APPLY_FILTER = `${SCOPE}/APPLY_FILTER`;
export const RESET_FILTER = `${SCOPE}/RESET_FILTER`;
export const UPDATE_INITIAL_CONFIGURATION = `${SCOPE}/UPDATE_INITIAL_CONFIGURATION`;
export const ASYNC_HTTP_REQ_STARTED = `${SCOPE}/ASYNC_HTTP_REQ_START`;
export const ASYNC_HTTP_REQ_ENDED = `${SCOPE}/ASYNC_HTTP_REQ_END`;
export const INTERVAL_SELECTION = `${SCOPE}/INTERVAL_SELECTION`;
export const UPDATE_GRANULARITY = `${SCOPE}/UPDATE_GRANULARITY`;
export const TOGGLE_MODAL = `${SCOPE}/TOGGLE_MODAL`;
export const UPDATE_FEATURES = `${SCOPE}/UPDATE_FEATURES`;
export const REFRESH_TRENDS = `${SCOPE}/REFRESH_TRENDS`;

/* TODO: For future reference,
 * Use below id in the editor to find the occurences of it's relative references.
 * Editor search key: dashboard_types_UUE93ID
 */
export const SET_PRESET = `${SCOPE}/SET_PRESET`;
export const CHANGE_ACTIVE_PRESET = `${SCOPE}/CHANGE_ACTIVE_PRESET`;
export const CHANGE_MAPPING_MODE = `${SCOPE}/CHANGE_MAPPING_MODE`;
export const SET_MAPPING_MODE_PRESET = `${SCOPE}/SET_MAPPING_MODE_PRESET`;
